import { useTranslation } from "react-i18next";

const POINTS = [
  "why.1",
  "why.2",
  "why.3",
  "why.4",
  "why.5",
  "why.6",
  "why.7",
  "why.8",
];

export default function Why() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold">{t("why.title")}</h2>
          <p className="mt-3 text-foreground-600">{t("why.subtitle")}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {POINTS.map((p) => (
            <div
              key={p}
              className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-check-line text-sm"></i>
              </span>
              <span className="text-sm font-medium text-foreground-800">{t(p)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}